import { defineMessages } from 'react-intl';

export default defineMessages({
    aboutCoverageTitle: {
        id: 'ml.quoteandbind.pa.quote.aboutCoverageTitle',
        defaultMessage: 'About the {offeringName} offering',
    },
    aboutValueHomeowners:{
        id: 'ml.quoteandbind.quote.hopdwelling.Value',
        defaultMessage: "The Value offering provides basic coverage and is our best priced plan.  Damage to your buildings and structures is covered unless excluded.  We pay Replacement Cost for your dwelling and other buildings.  Contents are covered for losses caused by Named Perils which are paid on an Actual Cash Value basis.  This means the value of new items minus depreciation."
    }, 
    aboutValuePlusHomeowners:{
        id: 'ml.quoteandbind.quote.hopdwelling.ValuePlus',
        defaultMessage: "The Value Plus offering provides standard coverage with a good balance of increased coverages at a competitive price.  We pay Replacement Cost for your dwelling and other buildings.  Contents are covered for losses caused by Named Perils which are paid on a Replacement Cost basis."
    },   
    aboutEnhancedHomeowners:{
        id: 'ml.quoteandbind.quote.hopdwelling.Enhanced',
        defaultMessage: "The Enhanced offering provides better coverage with higher limits and includes extra coverages.  We pay Guaranteed Rebuild for Dwelling and Replacement Cost for other buildings and contents.  Damage to your buildings and structures are covered unless excluded while contents are covered for losses caused by Named Perils."
    },
    aboutEnhancedPlusHomeowners:{
        id: 'ml.quoteandbind.quote.hopdwelling.EnhancedPlus',
        defaultMessage:  "The Enhanced Plus offering provides higher limits and includes extra coverages for customers who desire extra protection.  We provide Guaranteed Rebuild coverage for your dwelling and Replacement Cost on your other buildings and contents.  We cover your property with Comprehensive Perils which means losses are covered unless excluded."
    },
    aboutGrandProtectHomeowners:{
        id: 'ml.quoteandbind.quote.hopdwelling.GrandProtect',
        defaultMessage: "The GrandProtect offering provides the highest limits and most features for customers who desire extra protection.   This is our best coverage.  It provides coverage at a Blanket Property Limit.  Guaranteed Rebuild coverage is provided for your dwelling and outbuildings and Replacement Cost on contents.  We cover your property with Comprehensive Perils which means losses are covered unless excluded."
    },
    aboutValueCondo:{
        id: 'ml.quoteandbind.quote.hopcondo.Value',
        defaultMessage:  "The Value offering provides basic coverage and is our best priced plan.  It covers you for contents losses caused by Named Perils which are paid on an Actual Cash Value basis. Your condo unit amount of insurance is 10% of your contents limit unless you choose to increase it."
    },
    aboutValuePlusCondo:{
        id: 'ml.quoteandbind.quote.hopcondo.ValuePlus',
        defaultMessage: "The Value Plus offering provides standard coverage with a good balance of increased coverages at a competitive price.  Covered losses are paid using Replacement Cost on your condo unit and contents.  Damage to your unit is covered unless excluded while contents are covered for losses caused by Named Perils."
    },
    aboutEnhancedCondo:{
        id: 'ml.quoteandbind.quote.hopcondo.Enhanced',
        defaultMessage: "The Enhanced offering provides better coverage with higher limits and extra coverages already included.   Covered losses are paid using replacement cost on your condo unit and contents.  Damage to your unit is covered unless excluded.  Contents are covered for losses caused by Named Perils."
    },
    aboutEnhancedPlusCondo:{
        id: 'ml.quoteandbind.quote.hopcondo.EnhancedPlus',
        defaultMessage: "The Enhanced Plus offering provides better coverage with higher limits and extra coverages already included.  It covers you for Replacement Cost on your contents with Comprehensive Perils coverage which means loss is covered unless excluded."
    },
    aboutGrandProtectCondo:{
        id: 'ml.quoteandbind.quote.hopcondo.GrandProtect',
        defaultMessage: "The GrandProtect offering provides the highest limits and includes extra coverages for customers who desire extra protection.  This is our best coverage.  It provides coverage at a Blanket Property Limit.  It covers you for Replacement Cost on your condo unit and contents with Comprehensive Perils coverage which means loss is covered unless excluded."
    },
    aboutValueRenters:{
        id: 'ml.quoteandbind.quote.hoprental.Value',
        defaultMessage: "The Value offering provides basic coverage and is our best priced plan.  It covers you for contents losses caused by Named Perils.  Loss is paid on an Actual Cash Value basis which means the replacement value of the items minus depreciation."
    },
    aboutValuePlusRenters:{
        id: 'ml.quoteandbind.quote.hoprental.ValuePlus',
        defaultMessage: "The Value Plus offering provides standard coverage with a good balance of increased coverages at a competitive price.  Covered contents are paid using Replacement Cost for losses caused by Named Perils."
    },
    aboutEnhancedRenters:{
        id: 'ml.quoteandbind.quote.hoprental.Enhanced',
        defaultMessage: "The Enhanced offering provides better coverage with higher limits and extra coverages already included.  Covered losses are paid using replacement cost on contents.  Your household items and personal belongings are covered for losses caused by Named Perils."
    },
    aboutEnhancedPlusRenters:{
        id: 'ml.quoteandbind.quote.hoprental.EnhancedPlus',
        defaultMessage: "The Enhanced Plus offering provides better coverage with higher limits and extra coverages already included. It covers you for Replacement Cost on your contents with Comprehensive Perils coverage which means a loss is covered unless excluded."
    },
    aboutGrandProtectRenters:{
        id: 'ml.quoteandbind.quote.hoprental.GrandProtect',
        defaultMessage: "The GrandProtect offering provides the highest limits and extra coverages already included.  It provides coverage at a Blanket Property on your contents."
    },
    aboutValuePersonalAuto: {
        id: 'ml.quoteandbind.quote.pa.Value',
        defaultMessage: 'The Value offering includes basic Bodily Injury, Property Damage and Medical Expense coverages, as well as, Identify Theft Resolution coverage.  Comprehensive and Collision coverages are not included as part of this offering.  This offering provides basic coverages are the lowest premium.',
    },
    aboutValuePlusPersonalAuto: {
        id: 'ml.quoteandbind.quote.pa.ValuePlus',
        defaultMessage: 'The Value Plus offering includes basic Bodily Injury, Property Damage and Medical Expense coverages.  Comprehensive and Collision coverage are included with this offering, as well as, Identify Theft Resolution, Roadside Assistance and Rental Car Reimbursement coverages. This offering provides a balance of liability and physical damage coverages for customers looking for just the insurance basics.',
    },
    aboutEnhancedPersonalAuto: {
        id: 'ml.quoteandbind.quote.pa.Enhanced',
        defaultMessage: 'The Enhanced offering includes higher Bodily Injury, Property Damage and Medical Expense coverages.  Identify Theft Resolution coverage is also included.  Comprehensive and Collision coverages are not included as part of this offering.  This offering provides higher liability limits for your protection.',
    },
    aboutEnhancedPlusPersonalAuto: {
        id: 'ml.quoteandbind.quote.pa.EnhancedPlus',
        defaultMessage: 'The Enhanced Plus offering includes higher Bodily Injury, Property Damage and Medical Expense coverage limits. Comprehensive and Collision coverages are included as well as Diminishing Deductible, Identity Theft Resolution, $500 for key or lock replacement, $1,000 for Pet Medical Expenses and $2,000 for bike/bike racks or ski/ski racks carried by the vehicle.  This offering provides a good balance of higher-level coverages at a competitive price.',
    },
    aboutGrandProtectPersonalAuto: {
        id: 'ml.quoteandbind.quote.pa.GrandProtect',
        defaultMessage: 'The GrandProtect offering includes high-level Bodily Injury, Property Damage and Medical Expense coverage limits. Comprehensive and Collision coverages are included with this offering as well as Glass Deductible Waiver, Diminishing Deductible, Identity Theft Resolution, $500 for key or lock replacement, $1,000 for Pet Medical Expenses and $2,000 for bike/bike racks or ski/ski racks carried by the vehicle.  In addition, New Vehicle Replacement, Lease Loan Gap and Roadside Assistance and Rental Car Reimbursement are included with this offering. This offering was designed for customers who require more extensive coverage.',
    },
    aboutCustomCoverage: {
        id: 'ml.quoteandbind.pa.quote.aboutCustomCoverage',
        defaultMessage: 'This offering provides a customized level of limits and features selected by you to meet your insurance needs.',
    },
    aboutLandlordCoverage: {
        id: 'ml.quoteandbind.pa.quote.aboutLandlordCoverage',
        defaultMessage: 'This offering provides industry standard coverages such as Replacement Cost loss settlement for both the Dwelling and Contents.  This offering provides a good balance of coverages at a competitive price.',
    },
    quoteSubHeader: {
        id: 'ml.quoteandbind.pa.quote.quoteSubHeader',
        defaultMessage: 'Your quote number is {quoteNum}. You\'ll need this to access your quote in the future.'
    },
    howDoIKnowWhichIsBest: {
        id: 'ml.quoteandbind.pa.quote.howDoIKnowWhichIsBest',
        defaultMessage: 'How do I know which is best for me?'
    },
    comparePlans: {
        id: 'ml.quoteandbind.pa.quote.comparePlans',
        defaultMessage: 'Compare Plans'
    },
    clickCustomQuote: {
        id: 'ml.quoteandbind.pa.quote.clickCustomQuote',
        defaultMessage: 'Want to check other limits, coverages or premium options? Click to create a new custom quote.'
    },
    createCustomQuote: {
        id: 'ml.quoteandbind.pa.quote.createCustomQuote',
        defaultMessage: 'CREATE CUSTOM QUOTE'
    },
    includedFeatures: {
        id: 'ml.quoteandbind.pa.quote.includedFeatures',
        defaultMessage: 'Included Features'
    },
    perMonth: {
        id: 'ml.quoteandbind.pa.quote.perMonth',
        defaultMessage: '/month'
    },
    errorCreatingOfferings: {
        id: 'ml.quoteandbind.pa.quote.errorCreatingOfferings',
        defaultMessage: 'Error Creating Offerings'
    },
    errorCreatingOfferingsDesc: {
        id: 'ml.quoteandbind.pa.quote.errorCreatingOfferingsDesc',
        defaultMessage: 'Unable to create offering. Please try again.'
    },
    coverageLevel: {
        id: 'ml.quoteandbind.pa.quote.coverageLevel',
        defaultMessage: 'Choose Coverage Level'
    },
    sliderSubtitleDesktop: {
        id: 'ml.quoteandbind.pa.quote.sliderSubtitleDesktop',
        defaultMessage: 'Use the slider to choose a starting point for your custom quote'
    },
    sliderSubtitleMobile: {
        id: 'ml.quoteandbind.pa.quote.sliderSubtitleMobile',
        defaultMessage: 'Use the plus and minus buttons below to choose a starting point for your custom quote'
    },
    currentPremium: {
        id: 'ml.quoteandbind.pa.quote.currentPremium',
        defaultMessage: 'Current Premium'
    },
    amountPerMonth: {
        id: 'ml.quoteandbind.pa.quote.amountPerMonth',
        defaultMessage: '{premium}/month'
    },
    amountPer7Days: {
        id: 'ml.quoteandbind.pa.quote.amountPer7Days',
        defaultMessage: '{premium}/7 days'
    },
    changesMade: {
        id: 'ml.quoteandbind.pa.quote.changesMade',
        defaultMessage: 'Some changes were made to your quote'
    },
    requoting: {
        id: 'ml.quoteandbind.pa.quote.requoting',
        defaultMessage: 'Requoting'
    },
    requote: {
        id: 'ml.quoteandbind.pa.quote.requote',
        defaultMessage: 'Requote'
    },
    continue: {
        id: 'ml.quoteandbind.pa.quote.continue',
        defaultMessage: 'Continue'
    },
    continueToPurchase: {
        id: 'ml.quoteandbind.pa.quote.continueToPurchase',
        defaultMessage: 'Continue To Purchase'
    },
    perTermAnnual: {
        id: 'ml.quoteandbind.pa.quote.perTermAnnual',
        defaultMessage: '/year'
    },
    perTerm6Month: {
        id: 'ml.quoteandbind.pa.quote.perTerm6Month',
        defaultMessage: '/6 month'
    },
    premium7day: {
        id: 'ml.quoteandbind.pa.quote.premium7day',
        defaultMessage: '/7 days'
    },
    non7DaysMonthlyPremium: {
        id: 'ml.quoteandbind.pa.quote.non7DaysMonthlyPremium',
        defaultMessage: '/month'
    },
    hoNonRentReplacementCost: {
        id: 'ml.quoteandbind.pa.quote.hoNonRentReplacementCost',
        defaultMessage: 'Your estimated replacement cost for the dwelling is {erc}.'
    },
    hoRentalReplacementCost: {
        id: 'ml.quoteandbind.pa.quote.hoRentalReplacementCost',
        defaultMessage: 'Your estimated replacement cost for the contents is {erc}.'
    },
    hoCondoTooltip: {
        id: 'ml.quoteandbind.pa.quote.hoCondoTooltip',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your Condo unit with materials of like, kind and quality. These estimates are based upon information given to us from a professional construction valuating service. Many items attached as part of your condo unit may be your insurance responsibility as per the Condo Association By-Laws. Some Associations require unit owners to pay for interior construction materials such as drywall, paint, cabinetry, countertops and interior doors. It is important that you understand these requirements. If you are required to pay for such items, then you may need to increase your Replacement Cost coverage. This is the estimated amount needed to rebuild your unit if the association requires you to provide coverage.'
    },
    hoHomeTooltip: {
        id: 'ml.quoteandbind.pa.quote.hoHomeTooltip',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your home with materials of like, kind and quality. These estimates are based upon information given to us from a professional construction valuating service. This is our recommended amount necessary to rebuild your home, however, you can choose to change the amount of coverage for comparison. Your mortgage company may require you to maintain a specific level of replacement cost coverage on your policy.'
    },
    hoRentersTooltip: {
        id: 'ml.quoteandbind.pa.quote.hoRentersTooltip',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair or replace your personal property with items of like, kind and quality. This amount can be changed to reflect the amount of coverage that you need.'
    },
    customQuoteErrTitle: {
        id: 'ml.quoteandbind.pa.quote.customQuoteErrTitle',
        defaultMessage: 'Error Creating Offerings with changed term'
    },
    customQuoteErrDesc: {
        id: 'ml.quoteandbind.pa.quote.customQuoteErrDesc',
        defaultMessage: 'Unable to create offering with changed term. Please try again.'
    },
    aboutUmbrellaCoverage: {
        id: 'ml.quoteandbind.pa.quote.aboutUmbrellaCoverage',
        // eslint-disable-next-line no-template-curly-in-string
        defaultMessage: 'This offering provides ${amount} million of umbrella liability coverage. This offering provides basic umbrella coverage at a competitive price.',
    },
    recommendedOffering: {
        id: 'ml.quoteandbind.pa.quote.recommendedOffering',
        defaultMessage: 'Recommended'
    },
    payInFull: {
        id: 'ml.quoteandbind.common.quote.payInFull',
        defaultMessage: 'Pay in Full'
    },
    payByMortgagee: {
        id: 'ml.quoteandbind.common.quote.payByMortgagee',
        defaultMessage: 'Pay by Mortgagee'
    },
    payByRecurringAutomaticPayment: {
        id: 'ml.quoteandbind.common.quote.payByRecurringAutomaticPayment',
        defaultMessage: 'Pay by Recurring Automatic Payment'
    },
    payByCheck: {
        id: 'ml.quoteandbind.common.quote.payByCheck',
        defaultMessage: 'Pay By Check'
    },
    twoPaymentsOf: {
        id: 'ml.quoteandbind.common.quote.twoPaymentsOf',
        defaultMessage: '2 payments of:'
    },
    fourPaymentsOf: {
        id: 'ml.quoteandbind.common.quote.fourPaymentsOf',
        defaultMessage: '4 payments of:'
    },
    totalPremium: {
        id: 'ml.quoteandbind.common.quote.totalPremium',
        defaultMessage: 'Total premium:'
    },
    save: {
        id: 'ml.quoteandbind.common.quote.save',
        defaultMessage: 'Save'
    },
    oneFinalQuestion: {
        id: 'ml.quoteandbind.common.quote.One final question before we email your quote',
        defaultMessage: 'One final question before we email your quote'
    },
    thankYou: {
        id: 'ml.quoteandbind.common.quote.thankYou',
        defaultMessage: 'Thank you'
    },
    emailQuoteSent: {
        id: 'ml.quoteandbind.common.quote.emailQuoteSent',
        defaultMessage: 'An email with your quote has been sent to {emailAddress}.'
    },
    calculatingQuote: {
        id: 'ml.quoteandbind.common.quote.calculatingQuote',
        defaultMessage: 'Calculating Quote...'
    },
    liabilityMessage: {
        id: 'ml.quoteandbind.common.quote.liabilityMessage',
        defaultMessage: '<p><strong>Warning:</strong> If you suspend liability, the following coverages will also be suspended: Bodily Injury, Property Damage, Combined Single Limit, Uninsured Motorist, Underinsured Motorist, Uninsured and Underinsured Bodily Injury, Uninsured Property Damage, Personal Injury Protection and Medical coverage.</p><br></br><p>In an accident, the vehicle owner and driver could be held personally liable for any damages.  The vehicle may be considered uninsured and may be subject to penalty under the state’s motor vehicle laws.</p>'
    },
    paNamedExcludeAllSelectedMessage: {
        id: 'ml.quoteandbind.common.quote.paNamedExcludeAllSelectedMessage',
        defaultMessage: '{vehicleName} - All drivers have been checked for Named Driver Exclusion. Need to uncheck at least one driver or remove Named Driver Exclusion and comprehensive and collision coverages.'
    },
    paNamedExcludeNoneSelectedMessage: {
        id: 'ml.quoteandbind.common.quote.paNamedExcludeNoneSelectedMessage',
        defaultMessage: '{vehicleName} - Must select a driver to exclude  or remove Named Driver Exclusion.'
    },
    preexistingQuoteAlert: {
        id: 'ml.quoteandbind.common.quote.A customized quote was already created. It will be replaced with this new version',
        defaultMessage: 'A customized quote was already created. It will be replaced with this new version'
    },
    ak7DayWarningAlert: {
        id: 'ml.quoteandbind.common.quote.Quote is available as view only.  Contact us at 1-800-438-6381 for assistance.',
        defaultMessage: 'Quote is available as view only.  Contact us at 1-844-438-8430 for assistance.'
    },
    akNot7DayWarningAlert: {
        id: 'ml.quoteandbind.common.quote.To quote an Alaska 7 Day policy, contact us at 1-800-438-6381 for assistance.',
        defaultMessage: 'To quote an Alaska 7 Day policy, contact us at 1-844-438-8430 for assistance.'
    },
    deviceRemovedSuccessAlert: {
        id: 'ml.quoteandbind.common.quote.quote details banner',
        defaultMessage: 'Your Smart Home device has been removed. Your quoted premium has been adjusted.'
    },
    VTDECA: {
        id: 'ml.quoteandbind.common.quote.VTDE.CA_ML',
        defaultMessage: '{vin} vehicle qualifies for the Connected Car program but enrollment status indicates cancelled.  We are unable to apply the discount.'
    },
    VTDEEL: {
        id: 'ml.quoteandbind.common.quote.VTDE.EL_ML',
        defaultMessage: '{vin} vehicle qualifies for the Connected Car program but is not currently enrolled. If you enroll for a program through your vehicle manufacturer, you can update the vehicle on your policy to indicate Connected Car.'
    },
    VTDEIV: {
        id: 'ml.quoteandbind.common.quote.VTDE.IV_ML',
        defaultMessage: 'We\'re sorry, {vin} vehicle has an invalid VIN.  We are unable to apply the discount.'
    },
    VTDENE: {
        id: 'ml.quoteandbind.common.quote.VTDE.NE_ML',
        defaultMessage: 'We\'re sorry, {vin} vehicle is not eligible for the program.  We are unable to apply the discount.'
    },
    buildingPropertyLossSettlement: {
        id: 'ml.quoteandbind.common.quote.Building Property Loss Settlement option...',
        defaultMessage: 'Building Property Loss Settlement option is not valid as both Guaranteed and Functional have been selected. Changes are required to either the Property Details or Coverages.'
    },
    quotingCustomQuote: {
        id: 'ml.quoteandbind.common.quote.Quoting custom quote...',
        defaultMessage: 'Quoting custom quote...'
    },
    creatingOfferings: {
        id: 'ml.quoteandbind.common.quote.Creating offerings...',
        defaultMessage: 'Creating offerings...'
    },
    quoteWindstormHailDeductibleBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.quoteWindstormHailDeductibleBumpedWarning',
        defaultMessage: 'The Windstorm or Hail Deductible was updated to the minimum required deductible.'
    },
    quoteRoofLossSettlementBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.quoteRoofLossSettlementBumpedWarning',
        defaultMessage: 'Roof Loss Settlement was updated to Scheduled Roof as required.'
    },
    quoteAllOtherPerilBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.quoteAllOtherPerilBumpedWarning',
        defaultMessage: 'The All Other Perils deductible was updated to the minimum required deductible.'
    },
    quoteGrcAvailableBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.quoteGrcAvailableBumpedWarning',
        defaultMessage: 'Blanket Property and/or Guaranteed Rebuild is not available for this risk and the Building Property Loss Settlement and building code coverage have been updated.'
    }
});
